<template>
    <div>
        <div>

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>-产品列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                    <el-button round @click="exportExcel">导出</el-button>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="printClick">打印条码</el-button>
                    <span>-</span>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="download">下载模板</el-button>
                    <span>-</span>
                </p>
                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                        <el-button round type="primary">批量导入</el-button>
                        <span>-</span>
                    </el-upload>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="openDialog" type="primary">新增产品</el-button>
                    <span>-</span>
                </p>

                <div style="display:inline-block;width: 400px;">
                    <el-input placeholder="请输入产品编号/名称" v-model="queryValue" class="input-with-select">

                        <el-select v-model="statusValue" slot="prepend" placeholder="请选择" @change="selectProductStatus"
                            style="width:110px">
                            <el-option label="未审" value="0"></el-option>
                            <el-option label="已审" value="1"></el-option>

                            <el-option label="全部" value="-1"></el-option>
                        </el-select>

                        <el-button slot="append" icon="el-icon-search" @click="searchProduct"></el-button>
                    </el-input>
                </div>
            </div>

            <el-table :data="productList" row-key="id" style="width: 100%" @select="selectClick" @row-click="rowClick"
                ref="productTable" highlight-current-row v-loading="loading">

                <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
                </el-table-column>

                <el-table-column prop="imgUrl" label="产品图片" min-width="7%">
                    <template slot-scope="scope">
                        <el-image :src="'https://' + imagePath + scope.row.imgUrl"
                            v-if="scope.row.imgUrl == '' ? false : true"></el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="productCode" label="产品编号" min-width="10%">
                </el-table-column>
                <el-table-column prop="productName" label="产品名称" min-width="22%">
                </el-table-column>

                <el-table-column prop="moldCode" label="模具编号" min-width="10%" v-if="companyType == 0">
                </el-table-column>

                <el-table-column prop="productAmount" label="产品数量" min-width="3.5%" align="center">
                </el-table-column>

                <el-table-column prop="takeTime" label="标准周期(s)" min-width="6.75%" align="center">
                </el-table-column>
                <el-table-column prop="productWeight" label="产品重量(g)" min-width="6.75%" align="center">
                </el-table-column>

                <el-table-column prop="statusDes" label="状态" min-width="4%">
                </el-table-column>

                <el-table-column prop="annexAmount" label="附件数" min-width="8%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="280">
                    <template slot-scope="scope">
                        <el-button @click="lookClick(scope.row)" type="primary" round size="small">
                            查看
                        </el-button>

                        <el-button @click="handleClick(scope.row)" type="success" round size="small"
                            :disabled="scope.row.statusDes == '未审' ? false : true">
                            更改
                        </el-button>

                        <el-button @click="checkOrNoClick(scope.row)" type="success" size="small">{{
                        scope.row.statusDes == '未审' ? '审核' : '反审'
                    }}</el-button>

                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                            :disabled="scope.row.statusDes == '未审' ? false : true">
                            删除
                        </el-button>
                    </template>

                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="pageNum" :page-count="pageCount"
                    layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                    :page-sizes="[8, 10, 15, 20]" @size-change="handleSizeChange">
                </el-pagination>
            </div>

            <el-dialog title="产品详情" :visible.sync="dlgFormVisible" width="860px" style="">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                    <div style="display: flex;">

                        <div style="width:47%;margin-left:60px">

                            <el-form-item label="产品图片" :label-width="formLabelWidth" prop="imgUrl">
                                <el-upload class="avatar-uploader" action="#" :http-request="uploadImg"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">

                                    <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                </el-upload>
                            </el-form-item>

                            <el-form-item label="产品类别" required :label-width="formLabelWidth" prop="productType">
                                <el-select v-model="form.productType" placeholder="请选择" style="width:220px">
                                    <el-option v-for="item in form.prodTypeList" :key="item.value"
                                        :label="item.productTypeName" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div style="width:48%;margin-right:51px">
                            <el-form-item label="产品编号" required :label-width="formLabelWidth" prop="productCode">
                                <el-input v-model="form.productCode" autocomplete="off" style="width:220px"
                                    :disabled="productCodeDisable" @input="handleInput"></el-input>
                            </el-form-item>

                            <el-form-item label="产品名称" required :label-width="formLabelWidth" prop="productName">
                                <el-input v-model="form.productName" autocomplete="off" style="width:220px"></el-input>
                            </el-form-item>

                            <el-form-item label="产品数量" required :label-width="formLabelWidth" prop="productAmount"
                                v-if="companyType == 0">
                                <el-input-number v-model="form.productAmount" :step="1" :min="1"
                                    style="width:220px"></el-input-number>
                            </el-form-item>

                            <el-form-item label="模具编号" required :label-width="formLabelWidth" prop="moldCode"
                                v-if="companyType == 0">
                                <el-input v-model="form.moldCode" autocomplete="off" style="width:220px"></el-input>
                            </el-form-item>
                        </div>
                    </div>

                    <el-form-item label="工序" required :label-width="formLabelWidth" v-if="companyType == 1">
                        <el-select v-model="form.processNameArr" multiple placeholder="请选择" style="width:570px"
                            @change="processChange">
                            <el-option v-for="item in form.processList" :key="item.id" :label="item.processName"
                                :value="item.processName">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="标准周期(s)" :label-width="formLabelWidth" prop="takeTime">
                        <el-input v-model="form.takeTime" type="number" style="width:220px"></el-input>
                    </el-form-item>

                    <el-form-item label="产品重量(g)" :label-width="formLabelWidth" prop="productWeight">
                        <el-input v-model="form.productWeight" type="number" style="width:220px"></el-input>
                    </el-form-item>
                    <el-form-item label="材料配方" :label-width="formLabelWidth" prop="material">
                        <el-input v-model="form.material" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="仓位号" :label-width="formLabelWidth" prop="housePosition">
                        <el-input v-model="form.housePosition" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item> -->
                    <el-form-item label="规格" :label-width="formLabelWidth" prop="specifications">
                        <el-input v-model="form.specifications" autocomplete="off" style="width:220px"></el-input>
                    </el-form-item>

                    <el-form-item label="要求" :label-width="formLabelWidth">
                        <el-input v-model="form.remark" autocomplete="off" type="textarea"
                            style="width:570px"></el-input>
                    </el-form-item>

                    <div style="float: left;padding-left:60px;position: relative;">
                        <el-form-item label="补充资料" :label-width="formLabelWidth" prop="material">

                            <el-upload class="upload-demo" action="#" :http-request="uploadPDF"
                                :on-preview="handlePreview" :on-remove="handleRemove" :on-success="handleSuccess"
                                multiple :limit="3" :on-exceed="handleExceed" :file-list="form.fileList">

                                <el-button size="small" type="success">点击上传</el-button>
                            </el-upload>

                        </el-form-item>
                        <div style="width:140px;position:absolute;right:-150px;top:10px;">仅支持上传pdf文件，且不超过500kb</div>
                    </div>

                </el-form>

                <div style="width:380px;"></div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dlgFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="$event => addBaseProduct('ruleForm')" v-if="lookIf">保存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="打印条码" :visible.sync="printDlgVisible" width="50%">

                <div id="barcode-img" v-html="barcodeUrl"></div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="printDlgVisible = false">取 消</el-button>
                    <el-button type="primary" @click="printBarcode(1)">打 印</el-button>
                </div>
            </el-dialog>

            <el-dialog title="文件预览" :visible.sync="previewDlgVisible" width="1200px">
                <!-- <img :src="previewUrl" /> -->
                <iframe v-if="previewUrl" :src="previewUrl" width="99%" height="600px"></iframe>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "ProductBaseInfo",
    data() {
        var validateSpecial = (rule, value, callback) => {

            if (/[!@！#￥$%^&*()（）·`~<>《》?？]/.test(value)) {
                callback(new Error('不允许包含除 - 以外的特殊符号'));
            } else {

                callback();
            }
        }
        var validateBlank = (rule, value, callback) => {

            if (/\s\s/.test(value)) {
                callback(new Error('不允许包含连续2个或以上空格符'));
            } else {
                callback();
            }
        }
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),

            statusSearch: 0,
            companyType: 0,
            dlgFormVisible: false,

            productCodeDisable: false,

            form: {
                id: '',
                imgUrl: '',
                imgFile: {},
                productCode: '',

                prodTypeList: [],
                productType: '',
                productName: '',
                productAmount: '',
                takeTime: '',
                productWeight: '',
                material: '',
                housePosition: '',

                specifications: '',

                processIdArr: [],
                processNameArr: [],
                processList: [],

                moldCode: '',
                status: 0,
                remark: '',

                supList: [],

                fileList: []
            },

            formLabelWidth: '120px',
            productList: [],

            rules: {
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' },
                    { validator: validateBlank, trigger: 'blur' }
                ],
                productCode: [
                    { required: true, message: '请输入产品编号', trigger: 'blur' },
                    { required: true, message: '请输入产品编号', trigger: 'change' },
                    { validator: validateSpecial, trigger: 'blur' }
                ],
                productType: [
                    { required: true, message: '请选择产品类别', trigger: 'blur' },
                    { required: true, message: '请选择产品类别', trigger: 'change' }
                ],
                moldCode: [
                    { required: true, message: '请输入模具编号', trigger: 'blur' },
                    { required: true, message: '请输入模具编号', trigger: 'change' },
                    { validator: validateSpecial, trigger: 'blur' }
                ]
            },

            barcodeUrl: '',
            printDlgVisible: false,

            lookIf: true,
            previewUrl: '',
            previewDlgVisible: false,

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0,

            statusSearchVal: -1,
            queryValue: '',
            loading: false
        }
    },
    methods: {
        exportExcel() {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/excel",
                data: {
                    queryParam: this.queryValue,
                    status: this.statusSearchVal,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (result.status == 401) {
                    this.$message({
                        type: 'info',
                        message: result.msg
                    })
                    return
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "产品资料导出.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        handleInput(value) {

            this.form.productCode = value.replace(/[\u4e00-\u9fa5]/g, '')
        },
        selectProductStatus(value) {
            // console.log('Process.vue-->selectOrderStatus()')
            // console.log(value)

            this.statusSearchVal = parseInt(value)

            this.productList = []

            this.getAllBaseProduct()
        },
        searchProduct(query) {

            if (this.queryValue !== '') {



                this.getAllBaseProduct()

                // setTimeout(() => {

                // }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        selectClick(selection, row) {

            this.rowClick(row)
        },
        rowClick(row) {
            this.$refs.productTable.clearSelection()
            this.$refs.productTable.toggleRowSelection(row)

            this.form.id = row.id
            this.form.productCode = row.productCode

            if (row.status == 1) {
                this.processBtnDisable = true
            } else {
                this.processBtnDisable = false
            }
        },
        lookClick(row) {
            this.handleClick(row)

            this.lookIf = false
        },
        handleClick(row) {

            //console.log(row);
            this.productCodeDisable = true
            

            this.form.id = row.id

            this.form.productCode = row.productCode
            this.form.productName = row.productName

            this.form.productType = row.productType

            this.form.productAmount = row.productAmount
            this.form.takeTime = row.takeTime
            this.form.productWeight = row.productWeight
            this.form.material = row.material
            this.form.housePosition = row.housePosition

            this.form.specifications = row.specifications
            this.form.moldCode = row.moldCode
            this.form.status = row.status
            this.form.remark = row.remark

            if (row.supplementList != null && row.supplementList.length > 0) {
                for (let i in row.supplementList) {
                    row.supplementList[i].name = row.supplementList[i].fileName
                }
            }
            this.form.fileList = row.supplementList

            //
            if (this.companyType == 1) {
                this.form.processNameArr = []

                if (row.processNameStr.indexOf(",") != -1) {
                    this.form.processNameArr = row.processNameStr.split(",")
                } else {
                    this.form.processNameArr.push(row.processNameStr)
                }
            }

            this.lookIf = true
            this.dlgFormVisible = true
        },
        checkOrNoClick(row) {

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.checkBaseProduct(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })

        },
        checkBaseProduct(row) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/check",
                data: {
                    id: row.id,
                    status: row.status == 0 ? 1 : 0,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.getAllBaseProduct()
            })
        },
        openDialog() {
            this.form.id = ''

            this.form.productCode = ''
            this.form.productName = ''
            this.form.productType = ''

            this.form.productAmount = ''
            this.form.takeTime = ''
            this.form.productWeight = ''
            this.form.material = ''
            this.form.housePosition = ''
            this.form.specifications = ''

            this.form.status = 0
            this.form.remark = ''

            //工序
            this.form.processNameArr = []
            this.form.processIdArr = []

            this.productCodeDisable = false
            
            this.dlgFormVisible = true
            this.lookIf = true
        },
        deleteClick(row) {

            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // console.log('------deleteClick()')

                this.removeBaseProduct(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        printClick() {
            if (this.form.productCode == '') {
                this.$message({
                    type: 'info',
                    message: '请选择产品'
                })
                return
            }

            this.barcodeUrl = "<img src='https://" + this.imagePath + this.companyId + "/base/product/barcode/" + this.form.productCode + ".png'>"

            this.printDlgVisible = true
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/base/product/download",
                data: {},
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "产品资料导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        uploadImg(f) {
            console.log('uploadImg')
            console.log(f)

            this.form.imgFile = f.file
        },
        uploadFile(f) {
            // console.log(f)
            const form = new FormData()

            form.append('uploadFile', f.file)
            form.append('companyId', this.companyId)
            form.append('companyType', this.companyType)

            this.$axios({
                method: "post",
                url: "/shiro/base/product/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                this.getAllBaseProduct()
            })
        },
        uploadPDF(f) {
            const form = new FormData()

            form.append('uploadFile', f.file)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/base/product/pdf",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })

                var sup = data.data

                sup.name = sup.fileName
                this.form.fileList.push(sup)
            })
        },
        handleSuccess(response, file, fileList) {
            // console.log(response)
            // console.log(file)
            // console.log(fileList)
        },
        handleExceed() {
            this.$message({
                type: 'info',
                message: '最多上传3个文件'
            })
        },
        handlePreview(file) {
            // console.log(file)

            this.previewUrl = 'https://' + this.imagePath + file.fileUrl

            this.previewDlgVisible = true
        },
        handleRemove(file, fileList) {
            // console.log(file)
            // console.log(fileList)

            this.form.fileList = fileList

            this.$axios({
                method: "delete",
                url: "/shiro/base/supplement/rm",
                data: {
                    id: file.id,
                    fileUrl: file.fileUrl,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

            })
        },
        addBaseProduct(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    const form = new FormData()

                    form.append('id', this.form.id)


                    let arr = Object.keys(this.form.imgFile)
                    if (arr.length == 0) {
                        // console.log('000')
                        form.append('imgFile', new File([], 'file'))
                    } else {
                        form.append('imgFile', this.form.imgFile)
                    }

                    form.append('productCode', this.form.productCode)

                    form.append('productName', this.form.productName)
                    form.append('productType', this.form.productType)

                    form.append('productAmount', this.form.productAmount)
                    form.append('takeTime', this.form.takeTime)

                    form.append('productWeight', this.form.productWeight)
                    form.append('material', this.form.material)
                    form.append('housePosition', this.form.housePosition)

                    form.append('specifications', this.form.specifications)

                    form.append('moldCode', this.form.moldCode)

                    form.append('status', this.form.status)
                    form.append('remark', this.form.remark)

                    // form.append('supFileUrlList')
                    this.form.fileList.forEach((value, index) => {
                        form.append(`supplementList[${index}].id`, value.id)
                        form.append(`supplementList[${index}].fileName`, value.fileName)
                        form.append(`supplementList[${index}].fileUrl`, value.fileUrl)
                    })

                    // console.log('idarr')
                    // console.log(this.form.processIdArr)
                    this.form.processIdArr.forEach((value, index) => {
                        form.append(`processList[${index}].id`, value)
                        // form.append(`processList[${index}].processName`, value.processName)
                    })

                    form.append('operatorId', this.userId)
                    form.append('companyId', this.companyId)

                    this.$axios({
                        method: "post",
                        url: "/shiro/base/product/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {
                        const data = result.data

                        this.$message({
                            type: 'info',
                            message: data.msg
                        })

                        if (data.status != 200) {
                            return
                        }

                        this.dlgFormVisible = false

                        this.getAllBaseProduct()
                    })
                } else {
                    // console.log('error submit!!');
                    return false
                }
            })

        },
        getAllBaseProduct() {
            this.loading = true

            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: this.queryValue,
                    status: this.statusSearchVal,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.productList = data.data
                this.total = this.productList.length == 0 ? 0 : this.productList[0].total

                for (let i in this.productList) {
                    this.productList[i].createdTime = this.$moment(this.productList[i].createdTime).format("YYYY-MM-DD")

                    this.productList[i].annexAmount = this.productList[i].supplementList.length

                    if (this.productList[i].status == 0) {
                        this.productList[i].statusDes = '未审'
                    } else if (this.productList[i].status == 1) {
                        this.productList[i].statusDes = '已审'
                    }
                }

                this.loading = false
            })
        },
        removeBaseProduct(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/product/remove",
                data: {
                    id: row.id,
                    productCode: row.productCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllBaseProduct()
            })
        },
        //行拖拽
        rowDrop() {
            const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)

            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)

            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.productList.splice(newIndex, 0, _this.productList.splice(oldIndex, 1)[0])

                    var newArray = _this.productList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.productList = []

                    _this.$nextTick(function () {
                        _this.productList = newArray

                        this.sort(newArray)
                    })

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            const baseBOMInfoVOList = []

            this.$axios({
                method: "post",
                url: "/shiro/base/bom/sort",
                data: {
                    baseBOMInfoVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

            })
        },
        getAllProductType() {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/type/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.prodTypeList = data.data
            })
        },
        getAllProcess() {
            this.$axios({
                method: "post",
                url: "/shiro/base/process/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.processList = data.data
            })
        },
        processChange(val) {

            this.form.processIdArr = []
            for (let i in val) {

                const index = this.form.processList.findIndex(obj => obj.processName == val[i])
                // console.log(index)

                this.form.processIdArr.push(this.form.processList[index].id)
            }

        },
        pageClick(currentPage) {
            this.patrolPointList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllBaseProduct()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllBaseProduct()
        },
    },
    mounted() {
        this.setDefaultPath('/productBaseInfo')

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };

        this.rowDrop()//行拖拽

        this.$axios({
            method: "post",
            url: "/shiro/menu/get",
            data: {
                companyId: this.companyId
            }, headers: {
                token: this.token
            }
        }).then(result => {

            const data = result.data

            this.companyType = data.data.companyType

            //流水加工
            if (this.companyType == 1) {
                this.getAllProcess()
            }

        })

        this.getAllBaseProduct()

        this.getAllProductType()
    },
    updated() {

    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}

.el-dialog__body {
    overflow-y: auto;
}
</style>